module.exports = __webpack_public_path__ + "img/icon-paypal.0a71e5bd.svg";